import styled from 'styled-components';
import { TextButton as Button } from '../../../../design-system';
import { device } from '../../../styles/devices';

export const CtaGroupMobileWrapper = styled.div<{ isCaMarket?: boolean }>`
  display: flex;
  gap: 24px;
  flex-direction: row;
  margin-top: 12px;
  padding-top: 16px;
  width: 100%;
  justify-content: ${({ isCaMarket }) => (isCaMarket ? 'center' : 'flex-start')};
  @media ${device.laptop} {
    margin-top: unset;
    padding-top: 16px;
  }
`;

export const StyledTextButton = styled(Button)`
  span {
    margin-inline-start: 0;
  }
  div:nth-child(2) {
    flex-direction: row-reverse;
    gap: 4px;
  }
`;

export const ContactDealerCta = styled.button`
  cursor: pointer;
  font-family: 'Audi Type';
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
